import React from 'react';
import PropTypes from 'prop-types';

import IncentivePreferences from '../IncentivePreferences/IncentivePreferences';
import ToolTip from '../../../components/shared/ToolTip/ToolTip';

import SlideMilesDrivenDaily from '../../../components/InputComponents/SlideMilesDrivenDaily/SlideMilesDrivenDaily';
import SlideMaxBudget from '../../../components/InputComponents/SlideMaxBudget/SlideMaxBudget';
import SlideMinSeats from '../../../components/InputComponents/SlideMinSeats/SlideMinSeats';

import { FormattedMessage, useIntl } from 'react-intl';
import EVFilterControls from '../EVFilterControls/EVFilterControls';
import EVFilterType from './EVFilterType';
import EVFilterMake from './EVFilterMake';
import EVFilterAvailableNow from './EVFilterAvailableNow';
import NewUsedEVFilter from '../NewUsedEVFilter/NewUsedEVFilter';

const MatchScoreOptions = ({ electricVehicles, location, mobile, age }) => {
  const intl = useIntl();

  return (
    <>
      <div className="input-well MatchScoreOptions margin-top">
        {!mobile ? (
          <p className="h3">
            <FormattedMessage
              id="evs.matchScoreOptions"
              defaultMessage="Filters"
              description="Filters"
            />
          </p>
        ) : null}

        {!mobile ? (
          <div id="VehicleTypeFilter">
            <p className="age-title">
              <FormattedMessage
                id="evs.vehicleAge"
                defaultMessage="Vehicle age"
                description="Vehicle age"
              />
              <ToolTip
                id="vehicleAgeTooltip"
                message={
                  intl.formatMessage
                    ? intl.formatMessage({
                        id: 'evs.vehicleAgeTooltip',
                        defaultMessage:
                          'The most recently released model year will appear under New. For all prior year models, select Used.',
                      })
                    : 'The most recently released model year will appear under New. For all prior year models, select Used.'
                }
              />
            </p>
            <NewUsedEVFilter value={age} />
          </div>
        ) : null}

        <EVFilterControls vehicles={electricVehicles} />

        <SlideMaxBudget />
        <IncentivePreferences
          electricVehicles={electricVehicles}
          location={location}
          titleText={
            intl.formatMessage
              ? intl.formatMessage({
                  id: 'personalizeIncentives',
                  defaultMessage: 'Personalize incentives',
                })
              : 'Personalize incentives'
          }
          btnText={
            intl.formatMessage
              ? intl.formatMessage({
                  id: 'personalizeIncentives',
                  defaultMessage: 'Personalize incentives',
                })
              : 'Personalize incentives'
          }
          btnSubtle
        />

        <SlideMilesDrivenDaily />

        <SlideMinSeats />

        <EVFilterType />

        <EVFilterMake vehicles={electricVehicles} />
        <EVFilterAvailableNow />
      </div>

      {!mobile ? (
        <p className="selected-subText">
          <FormattedMessage
            id="evs.thirdParty"
            defaultMessage="We do not endorse or recommend any specific vehicle or car manufacturer. Vehicles displayed may not reflect actual availability."
            description="Vehicles Disclaimer"
            values={{
              company: process.env.REACT_APP_FULL_COMPANY_NAME,
            }}
          />
        </p>
      ) : null}
    </>
  );
};

export default MatchScoreOptions;

MatchScoreOptions.propTypes = {
  electricVehicles: PropTypes.array,
};
